import React from "react";
import {Image, ImageProps} from "../raw-components/image/image";
import {OrbitComponentWithState} from "../base-components/orbit-component-with-state/orbit-component-with-state";
import {AspectRatioContainerComponent} from '../raw-components/aspect-ratio-container/aspect-ratio-container.component';
import {HomepageHeaderArenaSkeletonBox} from './boxes/tiles/skeleton/home-page-header-arena-skeleton.box';
import { ByThemeRegistry } from "../../themes/architecture/by-theme-registry";

interface HomePageHeaderArenaTileComponentState {
    isLoading: boolean;
}

export class HomePageHeaderArenaTileComponent extends OrbitComponentWithState<ImageProps, HomePageHeaderArenaTileComponentState> {
    private aspectRatioSizes: ByThemeRegistry<{width: number; height: number;}> = new ByThemeRegistry({width: 295, height: 275});

    constructor(props: ImageProps) {
        super(props);

        this.state = {
            isLoading: true
        };
        this.aspectRatioSizes.forSI({width: 252, height: 150});
    }

    private _handleDoneLoading() {
        this.setState({ isLoading: false });
    }

    render() {
        return (
            <AspectRatioContainerComponent
                {...this.aspectRatioSizes.getRegistryItem(this.services.theme.themeName)}
            >
                <HomepageHeaderArenaSkeletonBox isLoading={this.state.isLoading} />
                <Image {...this.props} onLoad={() => this._handleDoneLoading()} />
            </AspectRatioContainerComponent>
        );
    }
}